import React from 'react'
import Footer from '../Layout/Footer'
import Header from '../Layout/Header'
import HowitsWork from '../components/HowitsWork'
import ImageReview from '../components/ImageReview'
import Pricing from '../components/Pricing'
import Squareone from '../components/Squareone'
import Squaretwo from '../components/Squaretwo'
import Accordins from '../components/acordin/Accordins'
import Review from '../components/review/Review'
export default function Home() {
  return (
    <div>
      <Header />
      <ImageReview />
      <HowitsWork />
      <Review />
      <Pricing />
      <Squareone />
      <Accordins />
      <Squaretwo />
      <Footer />
    </div>
  )
}
